<template>
    <div
        v-if="data"
        style="
            height: 100%;
            display: flex;
            width: 100%;
            flex-direction: column;
            gap: 10px;
            margin: 0 0 10px 0;
        "
    >
        <div
            style="
                display: flex;
                gap: 20px;
                background: #f8f8f8;
                padding: 20px;
                flex-wrap: wrap;
            "
        >
            <div
                style="
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    min-width: 300px;
                "
            >
                <strong style="font-size: 20px; line-height: 22px">{{
                    data["datasetName"]
                }}</strong>
                <div style="flex: 1; position: relative">
                    <div
                        style="
                            display: flex;
                            flex-direction: column;
                            gap: 10px;
                            position: absolute;
                            top: 0;
                            right: 0;
                            bottom: 0;
                            left: 0;
                            max-height: -webkit-fill-available;
                            overflow: scroll;
                            text-overflow: ellipsis;
                            margin: 10px 0 0;
                        "
                    >
                        <em style="font-size: 13px">{{
                            data["authors"] || ""
                        }}</em>
                        <div style="min-height:50px;">{{ data["summary"] || "" }}</div>
                    </div>
                </div>
            </div>
            <div style="display:flex; gap:10px">
                <div
                    style="
                        display: flex;
                        flex-direction: column;
                        border-left: 1px solid #ccc;
                        padding-left: 20px;
                        width: 25%;
                        min-width: 300px;
                    "
                >
                    <div class="metadata-item">
                        <div style="font-weight: bold; min-width: 100px">
                            Species
                        </div>
                        <div>{{ data["species"] }}</div>
                    </div>
                    <div class="metadata-item" v-if="data['organ']">
                        <div style="font-weight: bold; min-width: 100px">Organ</div>
                        <div style="text-transform: capitalize;">{{ data["organ"] }}</div>
                    </div>
                    <div class="metadata-item">
                        <div style="font-weight: bold; min-width: 100px">
                            Tissue
                        </div>
                        <div style="text-transform: capitalize;">{{ data["tissue"] }}</div>
                    </div>
                    <div class="metadata-item" v-if="data['depot']">
                        <div style="font-weight: bold; min-width: 100px">Depot</div>
                        <div style="text-transform: capitalize;">{{ data["depot"] }}</div>
                    </div>
                    <div class="metadata-item" v-if="data['depot2']">
                        <div style="font-weight: bold; min-width: 100px">
                            Sub-Depot
                        </div>
                        <div style="text-transform: capitalize;">{{ data["depot2"] }}</div>
                    </div>
                    <div class="metadata-item" v-if="data['totalCells']">
                        <div style="font-weight: bold; min-width: 100px">
                            Cell Count
                        </div>
                        <div>
                            {{
                                data["totalCells"] &&
                                data["totalCells"].toLocaleString()
                            }}
                        </div>
                    </div>
                    <div class="metadata-item" v-if="data['totalDonors']">
                        <div style="font-weight: bold; min-width: 100px">
                            Donors
                        </div>
                        <div>
                            {{
                                data["totalDonors"] &&
                                data["totalDonors"].toLocaleString()
                            }}
                        </div>
                    </div>
                    <div class="metadata-item" v-if="data['totalBiosamples']">
                        <div style="font-weight: bold; min-width: 100px">
                            Biosamples
                        </div>
                        <div>
                            {{
                                data["totalBiosamples"] &&
                                data["totalBiosamples"].toLocaleString()
                            }}
                        </div>
                    </div>
                    <div class="metadata-item" v-if="data['totalSamples']">
                        <div style="font-weight: bold; min-width: 100px">
                            Cells
                        </div>
                        <div>
                            {{
                                data["totalSamples"] &&
                                data["totalSamples"].toLocaleString()
                            }}
                        </div>
                    </div>
                    <div
                        class="metadata-item"
                        v-if="data['disease__ontology_label']"
                    >
                        <div style="font-weight: bold; min-width: 100px">
                            Disease
                        </div>
                        <template
                            v-if="Array.isArray(data['disease__ontology_label'])"
                        >
                            <div v-for="item in data['disease__ontology_label']">
                                {{ item }}
                            </div>
                        </template>
                        <template v-else>
                            <div>{{ data["disease__ontology_label"] }}</div>
                        </template>
                    </div>
                </div>
                <div
                    style="
                        display: flex;
                        flex-direction: column;
                        border-left: 1px solid #ccc;
                        padding-left: 20px;
                        width: 25%;
                        min-width: 300px;
                    "
                >
                    <div class="metadata-item" v-if="data['method']">
                        <div style="font-weight: bold; min-width: 100px">
                            Method
                        </div>
                        <div>{{ data["method"] }}</div>
                    </div>
                    <div class="metadata-item" v-if="data['assay']">
                        <div style="font-weight: bold; min-width: 100px">
                            Assay
                        </div>
                        <div>{{ data["assay"] }}</div>
                    </div>
                    <div class="metadata-item" v-if="data['platform']">
                        <div style="font-weight: bold; min-width: 100px">
                            Platform
                        </div>
                        <div>{{ data["platform"] }}</div>
                    </div>
                    <div class="metadata-item" v-if="data['contact']">
                        <div style="font-weight: bold; min-width: 100px">
                            Contact
                        </div>
                        <div style="overflow: hidden; overflow-wrap: break-word">
                            {{ data["contact"] }}
                        </div>
                    </div>
                    <div class="metadata-item" v-if="data['email']">
                        <div style="font-weight: bold; min-width: 100px">
                            Email
                        </div>
                        <div style="overflow: hidden; overflow-wrap: break-word">
                            {{ data["email"] }}
                        </div>
                    </div>
                    <div
                        class="metadata-item"
                        v-if="data['doi'] && data['doi'] !== 'NA'"
                    >
                        <div style="font-weight: bold; min-width: 100px">DOI</div>
                        <div style="overflow: hidden; overflow-wrap: break-word">
                            <a :href="data['doi']" target="_blank">{{
                                data["doi"].replace("https://doi.org/", "")
                            }}</a>
                        </div>
                    </div>
                    <div class="metadata-item" v-if="data['previous_versions']">
                        <div
                            style="
                                font-weight: bold;
                                min-width: 100px;
                                opacity: 0.7;
                            "
                        >
                            Prev. Versions
                        </div>
                        <div style="display: flex; flex-direction: column">
                            <div
                                v-for="(value, key) in data['previous_versions']"
                                style="overflow: hidden; overflow-wrap: break-word"
                            >
                                <a :href="value">{{ key }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="metadata-item" v-if="data['download']">
                        <div style="font-weight: bold; min-width: 100px">
                            Download
                        </div>
                        <div style="overflow: hidden; overflow-wrap: break-word">
                            <a :href="data['download']" target="_blank">here</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.component("research-single-cell-info", {
    props: {
        data: {
            type: Object,
            required: true,
        },
        displayDirection: {
            type: String,
            required: false,
            default: "horizontal",
        },
    },
    data() {
        return {};
    },
    watch: {},
    mounted() {},
    computed: {},
    methods: {},
});
</script>

<style scoped>
.metadata-item {
    display: grid;
    grid-template-columns: 0.7fr 1.3fr;
    font-size: 13px;
}
</style>
